import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-experiment-instruction',
  imports: [CommonModule],
  templateUrl: './experiment-instruction.component.html',
  styleUrl: './experiment-instruction.component.scss',
})
export class ExperimentInstructionComponent {
  @Input() message = '';
  @Input() isVisible = false;
  @Output() goNext = new EventEmitter<void>();
  @Output() restartRequest = new EventEmitter<void>();

  onClick() {
    this.goNext.emit();
  }

  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    if (event.key.toLowerCase() === 's') {
      this.restartRequest.emit();
    }
  }
}
